var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"rlc__header-c"},[_c('ResentLinkCardIcon',{attrs:{"icon":_vm.cardIcon}}),_c('ResentLinkCardTitle',{attrs:{"text":_vm.cardTitle}}),_c('ResentLinkCardSubtitle',{attrs:{"text":_vm.cardSubtitle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }